import React from "react";
import ModalV2 from "../../../../../shared/components/modalV2";
import { FEATURED_ICON } from "../../../../../assets";

function WarningPromptModal({
  isOpen,
  onClose,
  message = "Are you sure you want to delete this document?",

  onClick,
}: {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
  onClick: () => void;
}) {
  return (
    <ModalV2
      isOpen={isOpen}
      isClose={onClose}
      maxWidth="w-[448px]"
      edges="rounded-xl"
    >
      <div className="w-full py-8 px-10 flex gap-y-2 flex-col">
        <div className="w-full flex flex-col items-center justify-center gap-y-4">
          <img src={FEATURED_ICON} className="w-[56px] h-[56px]" alt="" />
          <span className="text-[#474747] text-xl font-semibold">
            {message}
          </span>
          <div className="w-full flex items-center gap-3 pb-5">
            <button
              onClick={onClose}
              className="w-full bg-[#E5E5E5] rounded p-3 text-[16px] font-medium text-[#515457]"
            >
              Cancel
            </button>
            <button
              onClick={onClick}
              className="w-full bg-[#217834] rounded p-3 text-[16px] font-medium text-white"
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </ModalV2>
  );
}

export default WarningPromptModal;
